export default __webpack_public_path__ + "static/media/online-shop.0faa10e6.png";